<!--
	TEMPLATE
-->
<template>
	<div class="" :id="itemdata.itemId">
		<div class="mdc-layout-grid marketplace-list__row" :class="{'marketplace-list__row--inactive': !isActive, 'marketplace-list__row--clicked': isClicked}" @click.prevent="showMore">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-2-phone marketplace-list__name editable-item__title">
					<i class="ico" :class="icon" v-show="icon ? true : false"></i>
					<div v-show="logo ? true : false" class="album-thumbnails">
						<img class="marketplace-list__name-logo" :src="logo" v-show="logo ? true : false">
					</div>
					<span>{{ title }}</span>
				</div>
				<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-1-phone marketplace-list__price">
					{{ priceString }}
				</div>
				<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-1-phone marketplace-list__status">
					<i class="ico" :class="{'ico-checkmark': isActive, 'ico-plus_math': !isActive && !isClicked}"></i><span class="ico ico-minus" v-show="!isActive && isClicked">-</span>
				</div>
			</div>
		</div>
		<div class="marketplace-list__toggle-content mdc-layout-grid" v-show="isClicked">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-2-phone marketplace-list__toggle-content__description">
					<span v-if="!description">( No information provided )</span>{{ description }}
				</div>
				<div v-if="priceString !== 'FREE' || (priceString == 'FREE' && itemdata.activable && this.itemdata.activable == 'Yes')" class="outputmsg mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-2-phone marketplace-list__toggle-content__activate">
					<div v-if="isActivating === false && isDeactivating === false">
						<div v-if="justActivated === true && isPaid === false && (itemdata.type == 'Recurring' || itemdata.type == 'One Time')">
							There was an issue charging for this item, please review your payment method.
						</div>
						<div v-if="activatedMessage != ''">
							<p>{{ activatedMessage }}</p>
						</div>
						<button type="button" class="activate mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn" @click.prevent="activate(itemdata.itemId)" v-if="!isActive">Activate</button>
						<button type="button" class="deactivate mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn btn--red" :class="{'btn-spin--visible' : isDeactivating}" @click.prevent="deactivate(itemdata.itemId)" v-else>{{ isDeactivating ? 'Deactivating' : 'Deactivate'}}</button>
					</div>
					<div v-else-if="isDeactivating === true">
						<p>Are you sure you want to deactivate this item?</p>
						<button type="button" class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn deactivateyes" @click.prevent="deactivateYes(itemdata.itemId)">Yes</button>
						<button type="button" class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn deactivateno" @click.prevent="deactivateNo(itemdata.itemId)">No</button>
					</div>
					<div v-else>
						<p>On activation you will immediately be charged with the following:</p>
						<small>
							{{ itemdata.quantity ? itemdata.quantity : 1 }} x {{ itemdata.title }} = <b>£{{ (calculated && itemdata.total !== itemdata.price) ? priceWithComma(calculated,2) : priceWithComma(itemdata.price,2) }} (+20% VAT)</b><br>
							<span v-if="(payDiff > 0 && payDiff < 31) && calculated && parseFloat(calculated) != parseFloat(itemdata.price)">
								Prorata of {{ payDiff == 0 ? 1 : payDiff}} days,
								Next bill on {{ payDate.toISOString().slice(0,10) }}
							</span>
						</small>
						<br><br>
						<div>
							<button type="button" class="accept mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn" @click.prevent="accept(itemdata.itemId)">Accept & Pay</button>
							<button type="button" class="cancel mdc-button btn-cancel" @click.prevent="cancel(itemdata.itemId)">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<!--
	SCRIPT
-->
<script>
import api from '@/libs/api.js';
import {store} from '../store'

export default {
	props: {
		title: String,
		icon: String,
		price: Number,
		logo: String,
		description: String,
		itemdata: Object
	},
	data: function() {
		return {
			isActive: this.itemdata.isactive,
			activatedMessage: '',
			isDeactivating: false,
			isActivating: false,
			calculated: {},
			payDay: 31,
			payDate: new Date(),
			payDiff: 0,
			justActivated: false,
			isPaid: false,
			isAccepted: false,
			isClicked: false,
			showSection: true,
			priceString: "£0"
		}
	},
	created: async function() {
		this.payDate = await this.$parent.Datex(this.$parent.tests_startDate);
		this.payDate.setDate(31);
		if (parseFloat(this.itemdata.price) === 0 || this.price === NaN) {
			this.priceString = 'FREE';
      if (!this.itemdata.activable || this.itemdata.activable == 'No')
			   this.isActive = true;
		} else {
			if (this.itemdata.type == 'Recurring'){
				this.priceString = "£"+parseFloat(this.price).toFixed(2);
				let frequency = this.itemdata.frequency.toLowerCase();
				switch(frequency) {
					case 'minute': frequency = '/minute'; break;
					case 'hourly': frequency = '/hour'; break;
					case 'daily': frequency = '/day'; break;
					case 'weekly': frequency = '/week'; break;
					case 'monthly': frequency = 'pm'; break;
					case 'quaterly': frequency = '/quarter'; break;
					case 'yearly': frequency = '/year'; break;
				}
				this.priceString += frequency;
			} else if (this.itemdata.type == 'Package'){
				this.priceString = "£"+parseFloat(this.price).toFixed(2)+"/"+this.itemdata.limit+" charges";
			} else if (this.itemdata.type == 'Per Usage'){
				let pertype="usage";
				if (this.itemdata.itemId == 'sms-registration')pertype = "SMS";
				this.priceString = "£"+parseFloat(this.itemdata.price).toFixed(2)+"/"+pertype;
			} else {
				this.priceString = "£"+parseFloat(this.itemdata.price).toFixed(2);
			}
		}
	},
	watch: {
		isAccepted: async function(val) {
			if (val === true) {
				this.activateFinal(this.itemdata.itemId);
			} else if (val === false) {
				this.cancel(this.itemdata.itemId);
			}
		},
	},
	computed: {
	},
	mounted: function() {
	},
	methods: {
    priceWithComma(price,decimals) {
			var splitPrice = price;
			if (typeof price != 'string') {
				splitPrice = splitPrice.toString();
			}

			if (splitPrice.indexOf(',') !== -1) {
				let resplitPrice = splitPrice.match(/\d+\,\d+/)[0];
				let rere = resplitPrice;
				rere = rere.replace(',','.');
				splitPrice = splitPrice.replace(resplitPrice,rere)
			}

			if (decimals) {
				splitPrice = parseFloat(splitPrice).toFixed(decimals);
			}

      	return splitPrice;
		},
		showSpinner(bid, id) {
			var element = document.getElementById(bid).getElementsByClassName(id)[0];
			if (element === undefined) {
				return false;
			}
			element.setAttribute("disabled","disabled");
			// element.setAttribute("style", "min-width:50px; height:49px");
			element.classList.add('btn-spin--visible');
			if (id.indexOf('deactivat') !== -1) {
				element.innerHTML = 'Deactivating';
				//document.getElementById(bid).getElementsByClassName('deactivateno')[0].setAttribute("style","display:none");
			} else if (id == 'accept') {
				element.innerHTML = 'Activating';
				//document.getElementById(bid).getElementsByClassName('cancel')[0].setAttribute("style","display:none");
			}
		},
		hideSpinner(bid, id) {
			var element = document.getElementById(bid).getElementsByClassName(id)[0];
			if (element === undefined) {
				return false;
			}

			element.classList.remove('btn-spin--visible');
			element.removeAttribute("style");
			element.removeAttribute("disabled");
      if (!this.itemdata.activable || this.itemdata.activable == 'No')
        element.innerHTML = id.charAt(0).toUpperCase() + id.slice(1);
			if (id == 'accept') {
				this.isActivating = false;
			}
		},
		showMore: function() {
			this.showSection = !this.showSection;
			this.isClicked = !this.isClicked;
    	},
		activateFinal: async function(bid) {
			const returnapi = await api({endpoint: this.config.services.billing, path: '/tracking', method: 'PUT', body: { itemId: this.itemdata.itemId }});
			if (this.itemdata.type === 'Recurring') {
				this.isActive = true;
				if (returnapi.paid === true) {
					await this.local_AddSubscription(this.itemdata.itemId);
				}
			}

			if (returnapi.msg)
				this.activatedMessage = returnapi.msg;
			if (returnapi.id) {
				if (!this.itemdata.lasttrack)
					this.itemdata.lasttrack = {};
				this.itemdata.lasttrack.trackId = returnapi.id;
			}
			this.justActivated = true;
			this.isPaid = returnapi.paid;
			this.$parent.services[this.itemdata.itemId].isactive = true;
			this.$parent.recalculate();
			this.hideSpinner(this.itemdata.itemId,'accept');
		},
		activate: async function(bid) {
			this.showSpinner(this.itemdata.itemId,'activate');
			const returnapi = await api({endpoint: this.config.services.payments, path: '/calc', method: 'POST', body: { itemId: this.itemdata.itemId } });
			if (returnapi && returnapi.error !== undefined && returnapi.error === false && returnapi.billitem[0]) {
				this.payDay = parseInt(returnapi.rdate);
				const nd = await this.$parent.Datex(this.$parent.tests_startDate);
				this.payDate = await this.$parent.Datex(this.$parent.tests_startDate);
				this.payDate.setDate(parseInt(returnapi.rdate));
				let interval = 0;
				if (parseInt(returnapi.rdate) <= (nd.getDate())) {
					interval = 1;
				}
				if (this.itemdata.type == 'Recurring' && (this.itemdata.frequency == 'Quarterly' || this.itemdata.frequency == 'Yearly')) {

				  	if (this.itemdata.frequency == 'Quarterly') interval += 3;
				  	else if (this.itemdata.frequency == 'Yearly') interval += 12;
					this.payDate.setMonth(this.payDate.getMonth() + interval);
				} else {
					this.payDate.setMonth(this.payDate.getMonth() + interval);
				}
				const diff = ((nd.getTime() > this.payDate.getTime()) ? (nd.getTime() - this.payDate.getTime()) : (this.payDate.getTime() - nd.getTime()));
				this.payDiff = parseInt((diff / 86400000).toFixed(0));
				this.calculated = returnapi.billitem[0].valuetopay;
				this.isActivating = true;
				this.hideSpinner(this.itemdata.itemId,'activate');
			} else {
        if (this.itemdata.activable && this.itemdata.price == 0 && returnapi.hascard === false) {
          this.activateFinal(this.itemdata.itemId);
          this.isActive = true;
        } else if (returnapi.hascard === false) {
					await this.$parent.setupCard();
					this.$parent.paymentMethodDialog = true;
					this.$parent.pendingItem = bid;
				} else {
					var el = document.getElementById(bid).getElementsByClassName('outputmsg')[0];
					if (el && returnapi && returnapi.error && returnapi.msg) {
						el.innerHTML = returnapi.msg;
						//alert(returnapi.msg);
					} else {
						el.innerHTML = "<p>Something went wrong calculating this subscription, please contact BestAgent team.</p>";
					}
				}
				this.hideSpinner(this.itemdata.itemId,'activate');
			}
		},
		accept: async function(bid) {
			this.showSpinner(bid,'accept');
			this.isAccepted = true;
		},
		cancel: async function(bid) {
			this.isAccepted = false;
			this.isActivating = false;
		},
		local_AddSubscription: async function(itemId) {
			let subs = this.$store.getters.subscriptions;
			subs.push(itemId);
			store.commit('setSubscriptions', subs);
		},
		local_DelSubscription: async function(itemId) {
			let subs = this.$store.getters.subscriptions;
			subs.filter(sub => {
				return sub != itemId;
			});
			store.commit('setSubscriptions', subs);
		},
		deactivateYes: async function(bid) {
			this.showSpinner(this.itemdata.itemId,'deactivateyes');
			const returnapi = await api({endpoint: this.config.services.billing, path: '/canceltracking', method: 'PUT', body: { itemId: this.itemdata.lasttrack.trackId } });
			await this.local_DelSubscription(this.itemdata.itemId);
			await this.$parent.recalculate();
			this.hideSpinner(this.itemdata.itemId,'deactivateyes');
			this.isActive = false;
			this.isDeactivating = false;
			this.isActivating = false;
			this.$parent.services[this.itemdata.itemId].isactive = false;
		},
		deactivateNo: async function(bid) {
			this.isDeactivating = false;
		},
		deactivate: async function(bid) {
			this.isDeactivating = true;
			if (this.itemdata.lasttrack) {
				this.isDeactivating = true;
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ServiceRow.vue